import { useCallback, useState } from 'react'
import Column from '@app/components/layout/Column'
import { useTranslations } from '@i18n/useLanguage'
import { TextInput } from '@app/components/core/input/text/TextInput'
import { Card } from '@app/components/blocks/card/Card'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCheck, faPlus } from '@fortawesome/pro-regular-svg-icons'
import { Text } from '@app/components/core/typography/Text'
import { useClient } from '@based/sdk/react'
import { useToast } from '@app/util/hooks/useToast'

export const AddCustomAmenityCard = ({
  initiativeId,
  onSelectId,
}: {
  initiativeId: number
  onSelectId: (id: number) => void
}) => {
  const creationTranslations =
    useTranslations().app.dashboard.initiative.creation
  const { showFailToast, showSuccessToast } = useToast()
  const [expanded, setExpanded] = useState(false)
  const [customName, setCustomName] = useState('')
  const client = useClient()

  const handleSave = useCallback(() => {
    const name = customName.trim()
    if (!name || !initiativeId) {
      return
    }
    client
      .call('create-amenity', {
        initiativeId,
        name,
      })
      .then((id) => {
        setCustomName('')
        showSuccessToast(creationTranslations.customAmenityAdded)
        onSelectId(id)
      })
      .catch(() => showFailToast())
  }, [
    client,
    initiativeId,
    customName,
    onSelectId,
    showFailToast,
    showSuccessToast,
    creationTranslations,
  ])

  if (expanded) {
    return (
      <TextInput
        text={customName}
        setText={setCustomName}
        placeholder={creationTranslations.amenityNamePlaceholder}
        onSubmit={handleSave}
        submitIcon={faCheck}
        style={{ gridColumn: '1 / span 3', height: '6.875rem' }}
      />
    )
  }

  return (
    <Card
      onClick={() => setExpanded(true)}
      style={{
        borderRadius: '0.9375rem',
        border: '1px solid var(--shades-blue-50)',
        height: '6.875rem',
        gridColumn: '1 / span 3',
      }}
    >
      <Column gap="0.5rem" alignItems="center">
        <FontAwesomeIcon
          icon={faPlus}
          style={{ height: '2rem', width: '2rem' }}
        />
        <Text.Small
          style={{
            color: 'var(--shades-blue-500)',
            textAlign: 'center',
            textWrap: 'wrap',
          }}
        >
          {creationTranslations.addOther}
        </Text.Small>
      </Column>
    </Card>
  )
}
